import React from 'react';

import { Step } from '@vlabs/uikit';
import cn from 'classnames';

import st from './shared.module.sass';
import { DeepfakeSubForm } from '../../../forms';

function StepDeepfake() {
  return (
    <Step className={cn(st.Step, st.NoTitle, st.FoldedStep)}>
      <DeepfakeSubForm />
    </Step>
  );
}

StepDeepfake.fieldNames = [
  'estiamte_deepfake',
];

export { StepDeepfake };
